<template>
  <v-container id="employee-report" fluid tag="section">
    <filter-form
        :currentPage="currentPage"
        :limit="limit"
        :filterForm="filterForm" 
        :ministries="ministries"
    />
    <!-- <DepartmentReportTable
      :filter-form="filterForm" :employeeReports="employeeReports" :totalReports="totalReports"
    />
    <common-no-result
      v-if="!employeeReports.length || totalItem === 0"
    /> -->
    <div class="d-flex justify-end">
      <v-menu offset-y>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on : tooltip }">
              <v-btn
                  color="purple"
                  dark
                  dense
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-download-multiple</v-icon>
              </v-btn>
            </template>
            <span>Số dòng hiển thị</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item-group
              v-model="selectedPageSize"
              color="grey"
              mandatory
          >
            <v-list-item
                v-for="(item, index) in items"
                :key="index"
                :value="item.value"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>
    <v-card>
      <DepartmentReportTable
        :employeeReports="employeeReports" :totalReports="totalReports" :roleName="roleName"
      />
      <common-no-result
        v-if="!employeeReports.length || totalItem === 0"
      />
      <v-row class="mt-4">
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
          <v-pagination
            v-if="totalItem > selectedPageSize"
            v-model="currentPage"
            class="justify-sm-end"
            :length="totalPage"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment'
import FilterForm from './components/FilterForm.vue'
import DepartmentReportTable from './components/DepartmentReportTable'
import { formatDate } from '@/helpers/utils'
import RepositoryFactory from "@/repositories/RepositoryFactory";
import { filterShiftCallCenter } from '../../../../helpers/constants'

const ReportRepository = RepositoryFactory.get('report');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')

export default {
  components: { FilterForm, DepartmentReportTable },
  data () {
    return {
      selectedPageSize: 10,
      items: [
        {
          title: '10',
          value: 10,
        },
        {
          title: '20',
          value: 20,
        },
        {
          title: '50',
          value: 50
        },
      ],
      filterShiftCallCenter,
      employeeReports: [],
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        shift: [],
        storeId: 0,
        ministryIds: []
      },
      store: [
        {
          text: 'Tất cả',
          value: 0
        },
        {
          text: 'Kho T',
          value: 1
        },
        {
          text: 'Kho C',
          value: 2
        },
        // {
        //   text: 'Kho G',
        //   value: 3
        // },
      ],
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      errorMessage: '',
      loading: false,
      totalReports: {},
      roleName: _.get(TokenService.getUser(), 'role.name', ''),
      watchModule: '',
      ministries: [],
    }
  },
  computed: {
    totalPage() {
      return this.getTotalItem(100, this.selectedPageSize)
    },
  },
  watch: {
    selectedPageSize() {
      if (this.currentPage === 1) {
        this.getDepartmentReport()
      } else {
        this.currentPage = 1
      }
    },
    currentPage: {
      handler() {
        this.getDepartmentReport()
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getDepartmentReport()
        } else {
          this.currentPage = 1
        }
      }
    }
  },
  created () {
    this.getListMinistry()
    this.getDepartmentReport()
    Bus.$on('department-report-list-filter', (filterForm) => {
      this.filterForm = filterForm
      this.getDepartmentReport()
      this.currentPage = 1
    })

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          dateRange: {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          shift: [],
          storeId: 0,
          ministryIds: []
        }
      
        Bus.$emit('department-report-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('department-report-list-filter');
    this.watchModule()
  },

  methods: {
    async getDepartmentReport () {
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        storeId: this.filterForm.storeId,
        shift: this.filterForm.shift,
        // ministryIds: this.filterForm.ministryIds,
        orgIds: this.filterForm.ministryIds,
        page: this.currentPage - 1,
        limit: this.selectedPageSize,
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        moduleName: _.get(this.$route, 'params.module', '')
      }
      params.paramV = this.$route.query.v;

      // if (!this.isManager()) {
      //   const dataUser = TokenService.getUser() || {};
      //   params.departmentId = dataUser.departmentId;
      // }

      const loader = this.$loading.show()
      const response = await ReportRepository.departmentEmployee(params)
      if (response.success) {
        this.employeeReports = _.get(response, 'data.rows', [])
        this.totalItem = _.get(response, 'data.count', 0)
        this.totalReports = _.get(response, 'data.total', {})
      }
      loader.hide()
    },

    async getListMinistry() {
      // const res = await OrganizationMachineRepository.listMinistryOnly()

      // Danh sách nhánh cấp 3
      const res = await OrganizationMachineRepository.listOrganizationByLevel({
        level: 3
      })

      if (res.success) {
        this.ministries = _.get(res, 'data', [])
      } else {
        this.ministries = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  },
}
</script>
